/**
 * 规范化安装包下载地址（相对路径、缺协议域名等）
 */
export function normalizeClientDownloadUrl(href) {
  if (href == null || href === "") {
    return "";
  }
  let u = String(href).trim();
  if (!u || u === "#") {
    return "";
  }
  if (/^https?:\/\//i.test(u)) {
    return u;
  }
  if (u.startsWith("//")) {
    return `${window.location.protocol}${u}`;
  }
  if (u.startsWith("/var/www/html/file/mac/version/")) {
    return `https://cloud.wird.com.cn/file/mac/version/${u.slice("/var/www/html/file/mac/version/".length)}`;
  }
  if (u.startsWith("/var/www/html/file/ios/version/")) {
    return `https://cloud.wird.com.cn/file/ios/version/${u.slice("/var/www/html/file/ios/version/".length)}`;
  }
  if (u.startsWith("/var/www/html/file/qt/version/")) {
    return `https://cloud.wird.com.cn/file/qt/version/${u.slice("/var/www/html/file/qt/version/".length)}`;
  }
  if (u.startsWith("/var/www/html/file/apk/version/")) {
    return `https://cloud.wird.com.cn/file/apk/version/${u.slice("/var/www/html/file/apk/version/".length)}`;
  }
  if (u.startsWith("/")) {
    return `${window.location.origin}${u}`;
  }
  if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(u)) {
    return `https://${u.replace(/^\/+/, "")}`;
  }
  return `${window.location.origin}/${u.replace(/^\/+/, "")}`;
}

export function filenameFromDownloadUrl(href) {
  if (!href) {
    return "";
  }
  try {
    const path = new URL(String(href), window.location.origin).pathname;
    const seg = path.split("/").filter(Boolean).pop();
    return seg ? decodeURIComponent(seg) : "";
  } catch (e) {
    const s = String(href).split("?")[0];
    const seg = s.split("/").filter(Boolean).pop();
    return seg || "";
  }
}

/** 列表行 / resolve 接口 → 建议保存到本地的文件名 */
export function resolveClientPackageFileName(row, resolveData, href) {
  if (resolveData) {
    const fromResolve =
      resolveData.download_file_name ||
      resolveData.file_real_name ||
      resolveData.fileRealName;
    if (fromResolve) {
      return String(fromResolve).trim();
    }
  }
  if (row) {
    const n =
      row.download_file_name ||
      row.file_real_name ||
      row.fileRealName ||
      row.file_name ||
      row.fileName;
    if (n) {
      return String(n).trim();
    }
  }
  return filenameFromDownloadUrl(href);
}

/**
 * 触发浏览器下载（直链兜底；跨域时 download 属性常被忽略）
 */
export function triggerClientDownload(href, fileName) {
  const url = normalizeClientDownloadUrl(href);
  if (!url) {
    return false;
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  if (fileName) {
    a.setAttribute("download", fileName);
  }
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return true;
}

/**
 * 在用户点击的同步调用栈内触发导航下载（避免 XHR 回调里 click 被拦截）
 */
export function triggerClientPackageDownloadSync(getDownloadUrl) {
  const url =
    typeof getDownloadUrl === "function" ? getDownloadUrl() : getDownloadUrl;
  if (!url) {
    return false;
  }
  const a = document.createElement("a");
  a.href = url;
  a.style.display = "none";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  window.setTimeout(() => {
    if (a.parentNode) {
      a.parentNode.removeChild(a);
    }
  }, 2000);
  return true;
}

/**
 * 优先 GET 同源代理（同步点击）；否则 XHR blob，最后直链
 */
export function triggerClientPackageDownload(options) {
  const {
    getDownloadUrl,
    downloadFileApi,
    payload,
    href,
    fileName,
    fallbackName,
  } = options || {};
  const name =
    (fileName && String(fileName).trim()) ||
    (fallbackName && String(fallbackName).trim()) ||
    filenameFromDownloadUrl(href);

  if (getDownloadUrl) {
    const url =
      typeof getDownloadUrl === "function" ? getDownloadUrl() : getDownloadUrl;
    if (url && triggerClientPackageDownloadSync(url)) {
      return Promise.resolve(true);
    }
  }

  if (downloadFileApi && payload) {
    return downloadFileApi(payload, name)
      .then(() => true)
      .catch((e) => {
        console.warn("client package proxy download failed", e);
        return triggerClientDownload(href, name);
      });
  }
  return Promise.resolve(triggerClientDownload(href, name));
}
